<template>
    <div
        class="container"
        ref="container"
        :style="{ height: containerHeight + 'px' }"
    >
        <div class="filter">
            <div class="left">
                <form-lookup
                    style="min-width: 200px; margin-right: 15px"
                    v-model="selectRoom.roomId"
                    placeholder="房源名称"
                    title="选择房间"
                    textSymbol="title"
                    valueSymbol="id"
                    :modalHeight="600"
                    :modalWidth="900"
                    :options.sync="selectRoom.roomList"
                    @change="onSelectRoom"
                    @clear="onClearRoom"
                    @deselect="onDeselectRoom"
                >
                    <select-room />
                </form-lookup>
                <check-tag-group
                    style="display: inline-block; min-width: 84px"
                    v-model="chooseYearOrMonth"
                    color="primary"
                >
                    <check-tag
                        v-for="item in btnList"
                        :name="item.id"
                        :key="item.id"
                    >
                        {{ item.text }}
                    </check-tag>
                </check-tag-group>
                <DatePicker
                    v-if="chooseYearOrMonth[0] === 1"
                    type="year"
                    placeholder="请选择年"
                    style="min-width: 100px"
                    v-model="year"
                />
                <DatePicker
                    v-else
                    type="month"
                    placeholder="请选择月"
                    style="min-width: 100px"
                    v-model="month"
                />
            </div>
            <div class="right">
                <div class="right-item">
                    总收入：<span class="price" style="color: #ff3739">{{
                        inAmount | currency
                    }}</span>
                </div>
                <div class="right-item">
                    总支出：<span class="price" style="color: #70b603">{{
                        outAmount | currency
                    }}</span>
                </div>
                <div class="right-item">
                    结余：<span class="price" style="color: #333333">{{
                        leftAmount | currency
                    }}</span>
                </div>
                <change-btn
                    @on-change="changeBtnIndex"
                    :currentIndex="currentIndex"
                />
            </div>
        </div>
        <div :style="{ height: contentHeight + 'px' }">
            <f-analysis-echart
                v-if="currentIndex === 0"
                :houseId="filter.houseId"
                :year="filter.year"
                :month="filter.month"
            />
            <f-analysis-data
                v-else
                :houseId="filter.houseId"
                :year="filter.year"
                :month="filter.month"
            />
        </div>
    </div>
</template>
<script>
import { mapCache } from '@/plugins/vux-data-cache'
import { debounce } from '_u/helper'

import mList from '_v/common/m-list'
import SelectRoom from '_vc/select-room'
import ChangeBtn from '_vc/change-btn'
import FAnalysisEchart from './f-analysis-echart'
import FAnalysisData from './f-analysis-data'

import { totalFeeStatistic } from '@/api/finance'

export default {
    name: 'f-analysis-list',
    mixins: [mList],
    components: {
        SelectRoom,
        ChangeBtn,
        FAnalysisEchart,
        FAnalysisData,
    },
    data() {
        return {
            page: {
                total: 0,
                list: [],
            },
            loading: false,
            containerHeight: 500,
            contentHeight: 420,
            currentIndex: 0,
            btnList: [
                { id: 1, text: '年' },
                { id: 2, text: '月' },
            ],
            chooseYearOrMonth: [1],
            inAmount: 0,
            outAmount: 0,
            leftAmount: 0,
        }
    },
    computed: {
        ...mapCache({
            filter: 'financeAnalysisIndex',
            selectRoom: 'financeAnalysisSelectRoom',
        }),

        columns() {
            return [
                {
                    type: 'index',
                    width: 80,
                    title: '序号',
                    align: 'center',
                },
                {
                    title: '房源名称',
                    key: 'name',
                    align: 'left',
                    minWidth: 120,
                },
                {
                    title: '客户姓名',
                    key: 'name',
                    align: 'center',
                    minWidth: 120,
                },
                {
                    title: '客户手机号',
                    key: 'name',
                    align: 'center',
                    minWidth: 120,
                },
                {
                    title: '费用类型',
                    key: 'name',
                    align: 'center',
                    minWidth: 120,
                },
                {
                    title: '金额(元)',
                    key: 'name',
                    align: 'center',
                    minWidth: 120,
                },
                {
                    title: '交易方式',
                    key: 'name',
                    align: 'center',
                    minWidth: 120,
                },
                {
                    title: '到账时间',
                    key: 'name',
                    align: 'center',
                    minWidth: 120,
                },
                {
                    title: '操作',
                    align: 'center',
                    width: 120,
                    key: 'action',
                },
            ]
        },
        year: {
            get() {
                return this.filter.year ? new Date(this.filter.year, 0, 1) : ''
            },
            set(val) {
                this.filter.year = val ? val.getFullYear() : ''
                this.filter.month = ''
            },
        },
        month: {
            get() {
                return this.filter.month
                    ? new Date(this.filter.year, this.filter.month - 1, 1)
                    : ''
            },
            set(val) {
                this.filter.year = val ? val.getFullYear() : ''
                this.filter.month = val ? val.getMonth() + 1 : ''
            },
        },
    },
    watch: {
        'filter.year'() {
            this.search()
        },
        'filter.month'() {
            this.search()
        },
        'filter.houseId'(val) {
            this.search()
        },
    },
    methods: {
        // btn下标更改
        changeBtnIndex(index) {
            this.currentIndex = index
        },
        fetch() {
            this.loading = true
            Promise.all([
                totalFeeStatistic({
                    houseId: this.filter.houseId,
                    year: this.filter.year,
                    month: this.filter.month,
                }),
            ]).then((args) => {
                const [data] = args
                this.outAmount = 0
                this.inAmount =
                    data.data.list.find((v) => v.flowType === '1').amount / 100
                this.outAmount -=
                    data.data.list.find((v) => v.flowType === '2').amount / 100
                this.leftAmount = this.inAmount + this.outAmount
                this.loading = false
            })
            // .finally(() => {
            //     this.loading = false;
            // });
        },
        search: debounce(500, function () {
            this.fetch()
        }),
    },
    created() {
        if (this.filter.month) {
            this.chooseYearOrMonth[0] = 2
        }
        if (!this.filter.year) {
            this.filter.year = new Date().getFullYear()
        }
        this.fetch()
    },
    mounted() {
        this.afterContainerResize((el, detector) => {
            const height =
                detector.windowHeight -
                this.$refs.container.getBoundingClientRect().top -
                20
            this.containerHeight = height < 500 ? 500 : height
            this.contentHeight = this.containerHeight - 80
        })
    },
}
</script>
<style lang="less" scoped>
.container {
    .filter {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        .left {
            min-width: 370px;
            display: flex;
        }
        .right {
            min-width: 650px;
            flex-grow: 1;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            &-item {
                margin-right: 20px;
                .price {
                    font-size: 16px;
                    padding-right: 10px;
                }
            }
        }
    }
}
</style>
